module.exports = window.top.jQuery;